import { Check, Plus, ScanFace } from "lucide-react";
import { previewUrl, rupiah } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export const PhotoCard = ({ photo, index = 0 }) => {
  const { inCart, toggle } = useCart();
  const { user } = useAuth();
  const selected = inCart(photo.id);
  const canBuy = !user || user.role === "member";

  return (
    <div className="group relative rounded-2xl overflow-hidden bg-zinc-100 border border-zinc-200 fade-up" style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }} data-testid={`photo-card-${photo.id}`}>
      <img src={previewUrl(photo.id)} alt={photo.event_title} loading="lazy" className="w-full aspect-[4/3] object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
      {photo.similarity != null && (
        <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-white/90 backdrop-blur px-2.5 py-1 text-xs font-bold text-blue-700" data-testid={`photo-similarity-${photo.id}`}>
          <ScanFace className="h-3.5 w-3.5" /> {photo.similarity}% cocok
        </span>
      )}
      <div className="flex items-center justify-between gap-3 p-3 bg-white">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-zinc-900 truncate">
            {photo.event_kind && <span className={`mr-1.5 align-middle rounded px-1.5 py-0.5 text-[10px] font-bold ${photo.event_kind === "non_event" ? "bg-amber-100 text-amber-800" : "bg-blue-100 text-blue-700"}`} data-testid={`photo-kind-${photo.id}`}>{photo.event_kind === "non_event" ? "Non Event" : "Event"}</span>}
            {photo.event_title}
          </p>
          <p className="text-xs text-zinc-500 truncate">{photo.photographer_name} · <span className="font-mono-x text-zinc-800" data-testid={`photo-price-${photo.id}`}>{rupiah(photo.price)}</span></p>
        </div>
        {canBuy && (
          <button onClick={() => toggle(photo)} data-testid={`photo-cart-toggle-${photo.id}`}
            className={`shrink-0 h-9 w-9 rounded-xl grid place-items-center transition-colors ${selected ? "bg-blue-600 text-white" : "bg-zinc-100 text-zinc-700 hover:bg-zinc-900 hover:text-white"}`}
            aria-label={selected ? "Hapus dari keranjang" : "Tambah ke keranjang"}>
            {selected ? <Check className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
          </button>
        )}
      </div>
    </div>
  );
};

export const PhotoGrid = ({ photos, empty }) =>
  photos.length === 0 ? (
    <div className="rounded-2xl border border-dashed border-zinc-300 bg-white py-20 text-center text-zinc-500" data-testid="photo-grid-empty">{empty}</div>
  ) : (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="photo-grid">
      {photos.map((p, i) => <PhotoCard key={p.id} photo={p} index={i} />)}
    </div>
  );
